import { render, staticRenderFns } from "./addCourseHainan.vue?vue&type=template&id=0cc5ff52"
import script from "./addCourseHainan.vue?vue&type=script&lang=js"
export * from "./addCourseHainan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports